import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[passwordToggle]',
})
export class PasswordToggleDirective {

  @Input() public elementTargetId: string = null;

  /**
   * Toggle the show password on click event
   *
   * @return void
   */
  @HostListener('click', [])
  public onClick(): void {
    this.toggle();
  }

  /**
   * Show or hide the password input value
   * toggle the elementTarget between input type 'password' or 'text'
   *
   * @return void
   */
  public toggle(): void {
    const elementTarget: Element = document.getElementById(this.elementTargetId);
    const elementType = elementTarget.getAttribute('type');

    elementTarget.setAttribute('type', elementType === 'password' ? 'text' : 'password');
  }
}
